export const AbrirEnRuta = () => {
  if (document.getElementById("enRuta"))
  document.getElementById("enRuta").style.display = "block";
  document.getElementById("contenedorEnRuta").style.display = "block";

  const enRuta = document.querySelector("#enRuta");

  if (enRuta) {
    enRuta.classList.remove("col-12");
    enRuta.classList.add("col-9");
    enRuta.classList.add("col-md-6");
    enRuta.classList.add("col-lg-7");
    enRuta.classList.add("col-xl-9");
    document.getElementById("contenedorRegresos").style.display = "none";
    // document.getElementById("contenedorNotificaciones").style.display = "none";
  }
};
export const CerrarEnRuta = () => {
  if (!document.getElementById("contenedorEnRuta")) return;
  document.getElementById("contenedorEnRuta").style.display = "none";
  const cerrar = document.querySelector(".icono-cerrar");
  const columna1 = document.querySelector("#enRuta");

  if (cerrar) {
    columna1.classList.remove("col-9");   
    columna1.classList.remove("col-md-6");
    columna1.classList.remove("col-lg-7");
    columna1.classList.remove("col-xl-9");
    columna1.classList.add("col-12");
    // columna1.classList.add("col-md-12");
    // columna1.classList.add("col-lg-12");
    // columna1.classList.add("col-xl-12");
  }
};
